import { Image } from "../image";

export interface BadgePrefixImageProps {
  src: string;
  alt?: string;
}

export const PrefixImage = (props: BadgePrefixImageProps) => {
  return (
    <Image
      src={props.src}
      width={16}
      draggable={false}
      height={16}
      className="mr-0.5 rounded-full object-cover"
      alt={props.alt || "prefix image of label"}
    />
  );
};
